var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-menu',[_c('b-menu-list',[_c('div',{staticClass:"menu-list"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }